(function(){
	// Protect scopes against minification
	siteSearchController.$inject = ['$scope', 'SUGUtilities','siteSearchService','$location','$window','$anchorScroll','globalService'];

	function siteSearchController($scope, util, siteSearchService, $location, $window, anchorScroll, globalService ){

		// initializes the controller when invoked
		var init = function(){
			/* Setting up pagination */
			$scope.currentPage = 1;
			$scope.maxSize = 15;
			$scope.totalItems = 0;
			$scope.numPerPage = 10;

			$scope.searchtext = '';
			$scope.searchstats = {};
			$scope.searchresult = [];
			$scope.showSearchResults = false;
			$scope.usenewaddirective = false;
			$scope.adconfig = {
					network :  '',
					platform : "desktop",
					category : "misc",
					section : "other",
					type : "",
					position : "",
					responsive : true
			};

			// Parse sitesearch value out of URL, store it in scope and run search on it, if it exists
			if (angular.isDefined($location.absUrl())) {
				var url = $location.absUrl();
				$scope.searchtext = getParameterByName("sitesearch", url);
				if (angular.isDefined($scope.searchtext)) {
					$scope.getSearchResults();
				}
			}

			// check if we need to use the new directive
			var d = { fuse:'c.sitesearch' };
			globalService.checkNewAdDirective( d )
				.then( function( newad ) {
					var r = util.lowerCaseKeys( newad );
					$scope.usenewaddirective = r.data.data;
				});
		};

		// parses url variables out of query string
		var getParameterByName = function (name, url) {
		    if (!url) url = window.location.href;
		    name = name.replace(/[\[\]]/g, "\\$&");
		    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		        results = regex.exec(url);
		    if (!results) return null;
		    if (!results[2]) return '';
		    return decodeURIComponent(results[2].replace(/\+/g, " "));
		};


		// retrieves search results based on specified search text
		$scope.getSearchResults = function(){
			siteSearchService.getSearchResults({"searchtext" : $scope.searchtext })
				.then(
					function(result){
						result = util.lowerCaseKeys(result);
						$scope.searchstats = angular.isDefined(result.data.data.stats) ? result.data.data.stats : {found:0};

						//angular.forEach(result.data.data.data, function (item) {
						//	item.summary =  $sce.trustAsHtml(item.summary);	//$sanitize(item.summary);
						//});
						$scope.searchresult = angular.isDefined(result.data.data.data) ? result.data.data.data : [];
						$scope.showSearchResults = true;
						$scope.currentPage = 1;
						$scope.totalItems = $scope.searchresult.length;
						//debugger;
					},
					function(result){
						util.showAlert('An error occurred retrieving the data.');
					}
				);
		};

		// used to open links since Angular seems to be blocking them.
		$scope.gotoLink = function(url) {
			$window.location.href = url;
		};

		// watch scope variables and update pagination accordingly when changes occur
		$scope.$watch('searchresult + totalItems + currentPage + numPerPage', function() {
			if (angular.isDefined($scope.searchresult) && $scope.searchresult.length ) {
				$scope.begin = ($scope.currentPage - 1) * $scope.numPerPage;
				$scope.end = $scope.begin + $scope.numPerPage;
				// read from the orginal data
				$scope.pageSlice = $scope.searchresult;

				//Paginate the resulting data
				if (angular.isDefined($scope.pageSlice.length)) {
					$scope.totalItems = $scope.pageSlice.length;
					$scope.pageSlice = $scope.pageSlice.slice($scope.begin, $scope.end);
				}

				if( $scope.currentPage > 1 ){
					$location.hash('topId');
					anchorScroll();
				}

			}
			else {
				// If no results are found, clear the pageSlice, reset totalItems and currentPage to default values so there are no issues with pagination display.
				$scope.pageSlice = [];
				$scope.totalItems = 0;
				$scope.currentPage = 1;
			}
		});

		// initialize the controller
		init();

	}

	angular.module('SUGApp').controller('siteSearchController',siteSearchController);

	// html filter (render text as html)
	SUGApp.filter('html', ['$sce', function ($sce) {
		return function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);

}());
